<script >
    import { createEventDispatcher } from 'svelte'
    import BoxedUserIco from '../icons/boxed-user.svelte'

    export let text = ''

    const dispatch = createEventDispatcher()

    function onChange(ev) {
        const file = ev.target.files[0]
        if (!file) {
            text = ''
            return
        }
        text = file.name
        dispatch('change', {file})
    }

</script>

<style lang="scss">
    .input-file {
        height: 60px;
        padding-left: 50px;
        position: relative;
        background: #2C322F;
        border-radius: 30px;
        display: block;
        cursor: pointer;
        .ico {
            position: absolute;
            top: 23px;
            left: 22px;
        }
        .text {
            opacity: 0.7;
            font-family: Roboto;
            font-size: 15px;
            color: #FFFFFF;
            letter-spacing: 0.04px;
            margin-bottom: 15px;
            line-height: 60px;
        }
        .button {
            position: absolute;
            top: 6px;
            right: 8px;
            height: 48px;
            line-height: 48px;
            background: #DF4937;
            font-family: Roboto;
            font-weight: 700;
            font-size: 13px;
            color: #FFFFFF;
            letter-spacing: 0.2px;
            padding: 0 16px;
            border-radius: 0 24px 24px 0;
        }
        input {
            top: 0;
            left: 0;
            position: absolute;
            visibility: hidden;
        }
    }
</style>

<label on:change={onChange} class="input-file">
    <div class="ico">
        <BoxedUserIco />
    </div>
    <div class="text">
        {text}
    </div>
    <div class="button">
        BROWSE...
    </div>
    <input type="file">
</label>


